import { render, staticRenderFns } from "./GroovyStep.vue?vue&type=template&id=81a3e74a"
import script from "./GroovyStep.vue?vue&type=script&lang=js"
export * from "./GroovyStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports